import * as constant from '../../global/const'

import { useState } from "react";

import axios from "axios";
import { useSelector } from 'react-redux';
import { TransparentLoader } from '../Loader/transparentLoader.component';

export const MisCreditos = () => {

    const [documentos, setDocumentos] = useState([]);
    const [mensajes, setMensajes] = useState([]);
    const backColors = ["", "", ""];
    const [loader, setLoader] = useState(false);
    const [show, setShow] = useState(false);
    const sucursal = useSelector(state => state.page.sucursal);

    const handleRemoveFile = (docName) => {
        const newFiles = documentos.filter(d => d.name != docName);
        setDocumentos(newFiles);
    }

    const handleFilesUploads = async () => {

        let formData = new FormData();
        setLoader(true);
        let suma = 0;

        documentos.map(
            d => {
                suma += d.size;
                formData.append("archivos", d);
            }
        )

        if (sucursal && documentos.length > 1 && suma < 20000000) {
            await axios.post(constant.SOLICITUDCREDITO + `?nit=${sucursal.nit}`, formData, { headers: { "Content-Type": "multipart/form-data" } })
                .then(
                    (response) => {
                        setLoader(false);
                        setShow(true);
                        setMensajes([response.data.message]);
                        setDocumentos([]);
                    }
                ).catch(
                    (err) => {
                        setLoader(false);
                        setMensajes(["Error, inconsistencias en envio de archivo"])
                        console.log(err.error);
                    }
                )
        } else {
            setMensajes(["No se aceptan mas de 20mb en archivos"]);
        }
    }

    const handleFiles = (e) => {

        const incomingFiles = handleIncomingFiles([...e.target.files]);

        documentos.length > 0
            ?
            setDocumentos([...documentos, ...incomingFiles])
            :
            setDocumentos(incomingFiles);

        e.target.value = ""

    }

    const handleFileCancel = (e, name) => {
        setDocumentos(documentos.filter((d) => d.name != name))
        handleRemoveFile(name);
    }

    const handleIncomingFiles = (incomingDocs) => {
        let auxFiles = [];
        let refusedFiles = [];

        //Recorrer los elementos entrantes, para determinar si pueden entrar o no
        incomingDocs.map(
            aux => {
                if (aux.size <= 2000000) {
                    auxFiles.push(aux);
                } else {
                    refusedFiles.push(
                        {
                            name: aux.name,
                            message: `Archivo rechazado, tamaño mayor a 2mb, actual ${aux.size / 1000000}mb`,
                        }
                    );
                }
            }
        )

        return auxFiles;
    }

    return (
        <>
            <div className="headerDatos">
                <h1>Mis creditos</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, nostrum ut placeat fugit atque, omnis facere non, itaque debitis odit delectus eos id aspernatur! Sapiente nam et nobis voluptate excepturi.</p>
            </div>

            <hr />

            <div className="content-misCreditos">
                <div className="content-misCreditos-header">
                    <h1>Solicita tu credito aquí</h1>
                    <a href="#">Ver instructivo</a>
                </div>

                <div className="content-misCreditos-body">
                    <h2><i className="fa fa-question-circle-o" aria-hidden="true"></i>1. Es muy simple:</h2>
                    <p>Descargar estos formularios debidamente diligenciados con su respectiva HUELLA y FIRMA</p>
                    <div className="content-misCreditos-body-cards">
                        <div className="content-misCreditos-body-cards-item">
                            <p>Persona Natural / Persona Jurídica</p>
                            <a target="_blank" href={ constant.URL_BASE_IMAGES + " SolicitudCredito/Natural_y_juridica.pdf"}>Descargar <i className="fa fa-file-pdf"></i></a>
                        </div>

                        <div className="content-misCreditos-body-cards-item">
                            <p>Pagaré y Carta de Instrucciones</p>
                            <a target="_blank" href={ constant.URL_BASE_IMAGES + " SolicitudCredito/Pagare_y_carta.pdf"}>Descargar <i className="fa fa-file-pdf"></i></a>
                        </div>
                    </div>

                    <h2><i className="fa fa-question-circle-o" aria-hidden="true"></i>2. Mandar:</h2>
                    <ul>
                        <li>Cámara de Comercio no superior a 30 días de emitida</li>
                        <li>RUT</li>
                        <li>Última declaración de renta</li>
                        <li>Referencia comercial y bancaria no superior a 3 meses de emitidas</li>
                        <li>Estados financieros de 2 últimos cortes fiscales (Diciembre) y si aplica: el último comercial ( mes diferente
                            a Diciembre) del año en curso. DEBIDAMENTE FIRMADOS</li>
                    </ul>
                </div>

                <hr />

                <div className="content-misCreditos-footer">
                    <p>Documentos Adjuntados</p>
                    <div className="content-misCreditos-footer-items">
                        {
                            loader
                                ?
                                <div style={{ width: "-webkit-fill-available" }}>
                                    <TransparentLoader />
                                </div>
                                :
                                documentos.map(
                                    (d, i) => {
                                        return (
                                            <div key={i + d.name} className="content-misCreditos-footer-items-item">
                                                {d.name}
                                                <div
                                                    className="circulo"
                                                    onClick={
                                                        (e) => {
                                                            handleFileCancel(e, d.name);
                                                        }
                                                    }
                                                >
                                                    <i className="fa fa-times" aria-hidden="true"></i>
                                                </div>
                                            </div>
                                        )
                                    }
                                )
                        }
                    </div>

                    <div
                        className="content-misCreditos-footer-items-messages"
                        style={
                            {
                                display: show ? "flex" : "none",
                            }
                        }
                    >
                        <h3>Mensaje(s)</h3>
                        {
                            mensajes.map(
                                (me, i) => {
                                    return (
                                        <p key={i + "mensaje"}>{me}</p>
                                    )
                                }
                            )
                        }
                    </div>


                    <div className="content-misCreditos-footer-action">
                        <div className="content-misCreditos-footer-action-input">
                            <p>Adjuntar documentos <i className="fa fa-paperclip" aria-hidden="true"></i></p>
                            <input
                                id="fileCredit"
                                title=""
                                type="file"
                                accept=".pdf,.docx,.jpg,.png"
                                data-multiple-caption=""
                                name="files-request"
                                onChange={handleFiles}
                                multiple
                            />
                        </div>
                        <button
                            onClick={
                                () => {
                                    handleFilesUploads();
                                }
                            }
                        >Enviar</button>
                    </div>
                </div>
            </div>
        </>
    )
}
